import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { AuthModule } from './auth/auth.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SpinnerComponent } from './core/components/spinner/spinner.component';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MsalRedirectComponent } from '@azure/msal-angular';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ReactiveFormsModule } from '@angular/forms';
import { MarkdownModule } from 'ngx-markdown';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { defineLocale, esLocale } from 'ngx-bootstrap/chronos';
defineLocale('es', esLocale);
import { TuiError, TuiRoot } from '@taiga-ui/core';
import { NG_EVENT_PLUGINS } from '@taiga-ui/event-plugins';
import { TuiFiles } from '@taiga-ui/kit';
import { TuiInputFiles } from '@taiga-ui/kit';
import { TuiButton } from '@taiga-ui/core';
import { TUI_LANGUAGE, TUI_SPANISH_LANGUAGE } from '@taiga-ui/i18n';
import { of } from 'rxjs';
import { LenguageSystemService } from './services/lenguage-system.service';
import { AccessDeniedComponent } from './pages/access-denied/access-denied.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent, SpinnerComponent, AccessDeniedComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MatDialogModule,
    MatSlideToggleModule,
    SharedModule,
    TuiRoot,
    ...TuiFiles,
    TuiInputFiles,
    TuiError,
    TuiButton,
    AuthModule,
    HttpClientModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    ReactiveFormsModule,
    MarkdownModule.forRoot(),
    DragDropModule
  ],
  exports: [SpinnerComponent],
  bootstrap: [AppComponent, MsalRedirectComponent],
  providers: [NG_EVENT_PLUGINS,
    {
      provide: TUI_LANGUAGE,
      useValue: of(TUI_SPANISH_LANGUAGE),
    }
  ],
})
export class AppModule {
  constructor(private translate: TranslateService, private LenguageSystemService: LenguageSystemService) {
    this.LenguageSystemService.initializeLanguageSystemOnce();
  }
}
